// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"wo_a bih_b"};